export default __webpack_public_path__ + "static/media/11.b46ef9ce.jpg";